import React, { ReactElement } from "react";
import { CartBlock, Container, LeftBlock, Line, PaymentBlock, RightBlock } from "./styles";

/**
 * Placeholder skeleton for the quick-checkout flow's pre-JS static shell.
 *
 * The quick-checkout webview is launched by native at 30% screen height, so this
 * layout is intentionally compact (no scroll) and anchors a footer CTA to the bottom.
 * Replace the inner blocks below with the final 30%-height design.
 */
const QuickCheckoutCartShimmer = (): ReactElement => {
    return (
        <Container data-testid="quick-checkout-cart-shimmer">
            <CartBlock>
                <Line height={24} />
            </CartBlock>

            <PaymentBlock>
                <LeftBlock>
                    <Line height={16} />
                    <Line width={60} height={16} />
                </LeftBlock>
                <RightBlock>
                    <Line height={58} />
                </RightBlock>
            </PaymentBlock>
        </Container>
    );
};

export default QuickCheckoutCartShimmer;
